import { useRoute } from 'vue-router'
import { useScrollPositionStore } from '~/stores/scrollPosition'

export function useScrollPosition() {
  const route = useRoute()
  const scrollPositionStore = useScrollPositionStore()

  function scrollToPosition() {
    const page = scrollPositionStore.page
    if (page !== route.name) return
    const cursorPosition = scrollPositionStore.position
    setTimeout(() => {
      window.scrollTo({
        top: cursorPosition,
        left: 0,
        behavior: 'smooth',
      })
    }, 100)
  }

  return { scrollToPosition }
}
